export default {
  'nav.catalog': 'الدورات', 'nav.live': 'الحصص المباشرة', 'nav.qa': 'اسأل خبيراً',
  'nav.consult': 'استشارة', 'nav.providers': 'الجهات', 'nav.myLearning': 'تعلّمي',
  'nav.certificates': 'الشهادات', 'nav.orders': 'المعاملات', 'nav.bookings': 'مواعيدي',
  'nav.admin': 'لوحة الإدارة', 'nav.verify': 'التحقق من الشهادة',
  'auth.login': 'تسجيل الدخول', 'auth.loginWith': 'الدخول عبر The Muslim', 'auth.logout': 'خروج',
  'auth.subtitle': 'استخدم حسابك في The Muslim — دون تسجيل جديد.',
  'auth.ssoContinue': 'المتابعة عبر The Muslim',
  'auth.ssoHint': 'سيتم نقلك إلى صفحة The Muslim. ليس لديك حساب؟ يمكنك التسجيل هناك.',
  'auth.cbWorking': 'جارٍ إتمام تسجيل الدخول…',
  'auth.cbFailed': 'لم يكتمل تسجيل الدخول',
  'auth.cbMissing': 'رابط العودة غير مكتمل. يرجى تسجيل الدخول مرة أخرى.',
  'auth.cbHome': 'إلى الصفحة الرئيسية',
  'hero.eyebrow': 'منصّة تربط الناس بالخبراء الموثوقين',
  'hero.title': 'تعلّم مباشرة من خبراء موثّقين',
  'hero.sub': 'دورات مسجّلة، حصص مباشرة، أسئلة للخبراء، واستشارات خاصة — في مكان واحد.',
  'hero.cta': 'استعرض الدورات', 'hero.cta2': 'دورات مجانية',
  'stat.learners': 'متعلّم', 'stat.courses': 'دورة منشورة', 'stat.experts': 'خبير موثّق', 'stat.certificates': 'شهادة صادرة',
  'home.categories': 'تصفّح حسب المجال', 'home.popular': 'الأكثر رواجاً', 'home.featured': 'اختيار المحرّرين',
  'home.free': 'ابدأ مجاناً', 'home.providers': 'الجهات الشريكة', 'home.experts': 'خبراء موثّقون',
  'home.live': 'مباشر وقريباً', 'home.seeAll': 'عرض الكل',
  'home.trust1': 'خبراء موثّقون', 'home.trust1d': 'كل خبير يمرّ بتحقّق من مؤهلاته قبل الانضمام.',
  'home.trust2': 'وصول سهل', 'home.trust2d': 'اسأل المتخصّص مباشرة دون تعقيد.',
  'home.trust3': 'إجابات موثوقة', 'home.trust3d': 'مرجعية من متخصّصين، لا مجرد رأي.',
  'catalog.title': 'كتالوج الدورات', 'catalog.filters': 'تصفية', 'catalog.reset': 'إعادة',
  'catalog.results': 'دورة', 'catalog.sort': 'ترتيب', 'catalog.search': 'ابحث عن دورة أو خبير',
  'level.beginner': 'مبتدئ', 'level.intermediate': 'متوسط', 'level.advanced': 'متقدّم', 'level.expert': 'متقدّم', 'level.all': 'كل المستويات',
  'price.free': 'مجاني', 'price.paid': 'مدفوع',
  'course.enroll': 'التسجيل الآن', 'course.enrollFree': 'انضم مجاناً', 'course.continue': 'متابعة التعلّم',
  'course.curriculum': 'المنهج', 'course.reviews': 'التقييمات', 'learn.title': 'تعلّمي',
  'cert.title': 'شهاداتي', 'qa.title': 'اسأل خبيراً', 'live.title': 'الحصص المباشرة',
  'consult.title': 'استشارة فردية', 'ui.loading': 'جارٍ التحميل…', 'ui.retry': 'إعادة المحاولة',
  'ui.empty': 'لا توجد بيانات', 'ui.verified': 'موثّق', 'ui.comingSoon': 'قريباً',
  'filter.category': 'المجال', 'filter.level': 'المستوى', 'filter.price': 'السعر', 'filter.rating': 'التقييم',
  'filter.language': 'اللغة', 'filter.features': 'المزايا', 'filter.provider': 'الجهة',
  'sort.most_popular': 'الأكثر رواجاً', 'sort.highest_rated': 'الأعلى تقييماً', 'sort.newest': 'الأحدث',
  'sort.price_low': 'الأقل سعراً', 'sort.price_high': 'الأعلى سعراً',
  'feat.certificate': 'شهادة', 'feat.quiz': 'اختبارات', 'feat.live': 'حصص مباشرة',
  'course.buy': 'شراء الدورة', 'course.preview': 'معاينة مجانية', 'course.objectives': 'ما ستتقنه',
  'course.requirements': 'ما تحتاج تجهيزه', 'course.audience': 'لمن هذه الدورة', 'course.about': 'عن الدورة',
  'course.instructor': 'المدرّب', 'course.related': 'دورات مشابهة', 'course.lessons': 'درس', 'course.modules': 'وحدة',
  'course.includes': 'تشمل', 'course.lifetime': 'وصول دائم', 'course.expiry': 'وصول {n} يوماً',
  'course.enrolled': '{n} متعلّم', 'course.lastUpdate': 'حُدّثت {d}', 'course.locked': 'مقفل',
  'checkout.title': 'ملخّص الطلب', 'checkout.coupon': 'رمز الخصم', 'checkout.apply': 'تطبيق',
  'checkout.pay': 'ادفع الآن', 'checkout.method': 'طريقة الدفع', 'checkout.total': 'الإجمالي',
  'checkout.subtotal': 'المجموع الفرعي', 'checkout.discount': 'الخصم', 'checkout.simulate': 'محاكاة Midtrans Snap',
  'checkout.success': 'تم الدفع بنجاح', 'checkout.startLearning': 'ابدأ التعلّم',
  'learn.inProgress': 'قيد التقدّم', 'learn.completed': 'مكتملة', 'learn.notStarted': 'لم تبدأ',
  'learn.resume': 'متابعة', 'learn.progress': '{n}% مكتمل',
  'player.next': 'الدرس التالي', 'player.prev': 'السابق', 'player.complete': 'تعليم كمكتمل',
  'player.previewNote': 'أنت تشاهد عيّنة مجانية من هذه الدورة. تُفتح بقية الدروس بعد التسجيل.', 'player.previewCta': 'عرض الدورة', 'player.otherLang': 'الفيديو باللغة {lang}',
  'player.notes': 'ملاحظات', 'player.resources': 'المواد', 'player.transcript': 'النص', 'player.discussion': 'النقاش',
  'player.speed': 'السرعة', 'player.captions': 'الترجمة', 'player.resume': 'المتابعة من {t}',
  // --- مساحة التعلّم (/learn) ---
  'player.exit': 'خروج', 'player.lessonOf': 'الدرس {n} من {total}',
  'player.remaining': 'المتبقّي {t}', 'player.shortcutHint': 'مسافة إيقاف · ←→ ٥ ث · J/L ١٠ ث · F ملء الشاشة',
  'player.videoMissing': 'لم يُرفع فيديو هذا الدرس بعد.',
  'player.videoBroken': 'الفيديو موجود لكن تعذّر إنشاء رابطه. أعد تحميل الصفحة.',
  'player.tamper': 'تمت إزالة علامة المالك، لذلك توقّف التشغيل. أعد تحميل الصفحة للمشاهدة مرة أخرى.',
  'player.throttled': 'طلبات فيديو كثيرة جدًا من هذا الحساب خلال ساعة واحدة. حاول مرة أخرى بعد قليل.',
  'player.linkDead': 'تعذّر تجديد رابط الفيديو. تحقّق من اتصالك ثم أعد تحميل الصفحة.',
  'player.nextUp': 'التالي', 'player.lastLesson': 'هذا آخر درس.', 'player.replay': 'إعادة',
  'player.markedDone': 'تم وضع علامة إتمام على الدرس',
  'player.liveNote': 'جلسة مباشرة لطلاب هذه الدورة. يُفتح الرابط قبل الموعد بعشر دقائق.',
  'player.liveCta': 'عرض جدول البث',
  'player.noteAdd': 'حفظ الملاحظة', 'player.notePlaceholder': 'اكتب ملاحظتك على هذا الدرس…',
  'player.notePlaceholderAt': 'اكتب ملاحظة عند {t}…',
  'player.notesEmpty': 'لا توجد ملاحظات بعد. ما تكتبه هنا يُحفظ في حسابك، فيبقى موجودًا عند فتحه من جهاز آخر.',
  'player.notesLoginTitle': 'الملاحظات تُحفظ في حسابك',
  'player.notesLoginHint': 'سجّل الدخول أولًا كي لا تضيع ملاحظاتك عند تغيير الجهاز.',
  'player.jumpTo': 'الانتقال إلى هذه اللحظة',
  'player.resourcesEmpty': 'لا توجد مواد للتنزيل في هذا الدرس.',
  'player.download': 'تنزيل', 'player.linkFailed': 'تعذّر إنشاء الرابط',
  'player.courseDone': 'اكتملت الدورة! 🎉',
  'player.courseDoneNote': 'صدرت شهادتك ويمكن التحقق منها علنًا عبر رمزها الفريد.',
  'player.viewCert': 'عرض الشهادة',
  'ui.edit': 'تعديل', 'ui.delete': 'حذف',
  'adm.res.title': 'مواد للتنزيل', 'adm.res.add': 'إضافة ملف',
  'adm.res.added': 'تمت إضافة الملف',
  'adm.res.tooBig': 'الحجم الأقصى للملف ٢٥ ميغابايت.',
  'adm.res.hint': 'أرفق الشرائح أو أوراق العمل أو ملخصًا. PDF أو صورة، حتى ٢٥ ميغابايت. صدّر الشرائح إلى PDF أولًا.',
  'quiz.start': 'ابدأ الاختبار', 'quiz.submit': 'إرسال', 'quiz.retry': 'إعادة المحاولة',
  'quiz.passed': 'ناجح', 'quiz.failed': 'لم تنجح بعد', 'quiz.score': 'الدرجة', 'quiz.attempt': 'المحاولة {n}',
  'cert.download': 'تنزيل PDF', 'cert.share': 'المشاركة على LinkedIn', 'cert.verify': 'تحقّق',
  'cert.serial': 'الرقم التسلسلي', 'cert.issued': 'صدرت',
  'cert.valid': 'هذه الشهادة صحيحة ومسجّلة', 'cert.invalid': 'الشهادة غير موجودة',
  'cert.verifyTitle': 'التحقق من شهادة', 'cert.verifyHint': 'أدخل رمز التحقق المطبوع على الشهادة',
  'qa.ask': 'اطرح سؤالاً', 'qa.answered': 'مُجاب', 'qa.open': 'بانتظار الإجابة',
  'qa.yourQuestion': 'سؤالك', 'qa.detail': 'تفاصيل السؤال', 'qa.send': 'إرسال السؤال',
  'qa.sub': 'أرسل سؤالك إلى خبير موثّق. مجاني في الإصدار الأول — والإجابات معلنة ليستفيد منها الجميع.',
  'qa.field': 'المجال', 'qa.askWho': 'إلى مَن توجّه السؤال', 'qa.anyExpert': 'أي خبير في هذا المجال',
  'qa.askWhoHint': 'اتركه فارغًا إن لم يكن موجّهًا لشخص بعينه — الأسئلة المفتوحة تُجاب عادةً أسرع.',
  'qa.field.title': 'سؤال مختصر', 'qa.field.titlePh': 'مثال: ما حكم…؟',
  'qa.field.body': 'التفاصيل', 'qa.field.bodyHint': 'كلما زادت التفاصيل كانت الإجابة أدقّ',
  'qa.publicNote': 'الأسئلة المُجابة تظهر للعموم دون بياناتك الشخصية.',
  'qa.sent': 'أُرسل السؤال — سيجيب أحد الخبراء خلال 1–3 أيام عمل.',
  'live.now': 'مباشر الآن', 'live.upcoming': 'قريباً', 'live.ended': 'انتهت',
  'live.join': 'دخول الحصة', 'live.remind': 'ذكّرني', 'live.reminded': 'التذكير مفعّل', 'live.viewers': '{n} يشاهدون',
  'consult.book': 'اختر موعداً', 'consult.slots': '{n} موعد متاح', 'consult.from': 'من',
  'consult.confirm': 'تأكيد الحجز', 'consult.notes': 'صف حاجتك باختصار',
  'admin.dashboard': 'لوحة المعلومات', 'admin.guide': 'الدليل', 'admin.courses': 'الدورات', 'admin.instructors': 'الخبراء',
  'admin.live': 'الحصص المباشرة', 'admin.qa': 'اسأل خبيراً', 'admin.consult': 'الاستشارات',
  'admin.enrollments': 'التسجيلات', 'admin.reviews': 'التقييمات', 'admin.earnings': 'الإيرادات',
  'admin.slots': 'مواعيد الاستشارة', 'admin.certificates': 'الشهادات', 'admin.coupons': 'الكوبونات',
  'admin.notifications': 'الإشعارات', 'admin.certTemplates': 'قوالب الشهادات', 'admin.audit': 'سجل التدقيق',
  'admin.providers': 'الجهات', 'admin.categories': 'التصنيفات', 'admin.payouts': 'التحويلات',
  'admin.platformOnly': 'خاص بالمنصة', 'admin.approvalQueue': 'بانتظار المراجعة',
  'admin.selected': 'تم اختيار {n}', 'admin.approve': 'اعتماد', 'admin.reject': 'رفض', 'admin.archive': 'أرشفة',
  'admin.bulk': 'إجراءات جماعية', 'admin.newCourse': 'دورة جديدة', 'admin.editCurriculum': 'تحرير المنهج',
  'status.draft': 'مسودة', 'status.pending_review': 'بانتظار المراجعة', 'status.published': 'منشورة',
  'status.rejected': 'مرفوضة', 'status.archived': 'مؤرشفة', 'status.active': 'نشطة', 'status.completed': 'مكتملة',
  'status.paid': 'مدفوعة', 'status.pending': 'معلّقة', 'status.failed': 'فاشلة', 'status.held': 'محجوزة',
  'status.payable': 'قابلة للصرف', 'status.processing': 'قيد المعالجة',
  'ui.error': 'حدث خطأ ما', 'ui.emptyHint': 'جرّب تغيير التصفية أو الكلمات المفتاحية.',
  'ui.save': 'حفظ', 'ui.cancel': 'إلغاء', 'ui.close': 'إغلاق', 'ui.search': 'بحث',
  'ui.all': 'الكل', 'ui.page': 'صفحة', 'ui.of': 'من', 'ui.viewMode': 'العرض', 'ui.design': 'نمط التصميم',

  // ---- portal admin: label yang dipakai lintas-halaman ----
  'adm.col.actions': 'إجراءات', 'adm.col.provider': 'الجهة', 'adm.col.instructor': 'الخبير',
  'adm.col.status': 'الحالة', 'adm.col.price': 'السعر', 'adm.col.students': 'المتعلّمون',
  'adm.col.no': 'الرقم',
  'adm.col.course': 'الدورة', 'adm.col.schedule': 'الموعد', 'adm.col.time': 'الوقت',
  'adm.col.duration': 'المدة', 'adm.col.field': 'المجال', 'adm.col.updated': 'آخر تحديث',
  'adm.col.notes': 'ملاحظات', 'adm.col.position': 'الترتيب', 'adm.col.key': 'المعرّف',
  'adm.col.score': 'الدرجة', 'adm.col.scope': 'النطاق',
  'adm.table.clear': 'مسح',
  'adm.val.inactive': 'غير نشط', 'adm.val.platform': 'المنصة', 'adm.val.default': 'افتراضي',
  'adm.val.pending': 'قيد الانتظار', 'adm.val.notYet': 'لم يتم', 'adm.val.yes': 'نعم',
  'adm.val.minutes': '{n} د',
  'adm.lang.id': 'الإندونيسية', 'adm.lang.en': 'الإنجليزية', 'adm.lang.ms': 'الملايوية', 'adm.lang.ar': 'العربية',
  'adm.field.category': 'التصنيف', 'adm.field.priceIdr': 'السعر (IDR)', 'adm.field.logo': 'الشعار',
  'adm.field.accentColor': 'لون التمييز (hex)',
  'adm.field.providerHint': 'مدير الجهة يستخدم جهته تلقائياً.',
  'adm.bulk.activate': 'تفعيل', 'adm.bulk.deactivate': 'إلغاء التفعيل',
  'adm.bulk.markComplete': 'تعليم كمكتمل', 'adm.bulk.approvePublish': 'اعتماد ونشر',
  'adm.bulk.unpublish': 'إرجاع إلى مسودة',
  'adm.bulk.updated': 'تم تحديث {n} صفاً', 'adm.bulk.rejected': 'تم رفض {n} صفاً',
  'adm.filter.all': '{field}: الكل',

  // ---- portal admin: form generik (ResourcePage) ----
  'adm.form.required': '{field} مطلوب', 'adm.form.selectField': '— اختر {field} —',
  'adm.form.optionsFailed': 'تعذّر تحميل الخيارات', 'adm.form.saved': 'تم حفظ التغييرات',
  'adm.form.created': 'تمت الإضافة بنجاح', 'adm.form.saveFailed': 'تعذّر الحفظ',
  'adm.form.deleted': 'تم حذف البيانات', 'adm.form.deleteFailed': 'تعذّر الحذف',
  'adm.form.edit': 'تعديل', 'adm.form.add': 'إضافة', 'adm.form.delete': 'حذف',
  'adm.form.deleteTitle': 'تأكيد الحذف',
  'adm.form.deleteDefault': 'حذف هذه البيانات؟ يمكن التراجع عن ذلك عبر قاعدة البيانات (حذف مؤقت).',
  'adm.reject.title': 'سبب الرفض', 'adm.reject.confirmN': 'رفض {n} دورة',
  'adm.reject.note': 'يُرسَل السبب إلى الجهة ويظهر في لوحتها. وضّح ما يجب تصحيحه.',
  'adm.reject.ph': 'مثال: صوت الوحدة 2 متقطّع عند الدقيقة 04:12 — يُرجى إعادة التسجيل.',

  // ---- portal admin: kelas ----
  'adm.courses.sub': 'راجع الدورات وانشرها ورتّب مناهجها.',
  'adm.courses.add': 'إضافة دورة', 'adm.courses.createTitle': 'إضافة دورة جديدة',
  'adm.courses.createdMsg': 'أُنشئت الدورة كمسودة — أكمل المنهج ثم أرسلها للمراجعة.',
  'adm.courses.formSub': 'أنشئ هيكل الدورة أولاً (بحالة مسودة). أما المنهج والوحدات والاختبارات وتفاصيل السعر فتُضبَط في محرّر الدورة.',
  'adm.courses.newCourseToast': 'نموذج دورة جديدة: POST /admin/courses',
  'adm.courses.field.title': 'عنوان الدورة', 'adm.courses.field.titlePh': 'مثال: تحسين تلاوة القرآن للمبتدئين',
  'adm.courses.field.subtitle': 'العنوان الفرعي', 'adm.courses.field.subtitlePh': 'يظهر على البطاقة وفي صدر الصفحة',
  'adm.courses.field.instructor': 'الخبير المدرّب',
  'adm.courses.field.instructorHint': 'يجب أن يكون خبيراً من الجهة نفسها.',
  'adm.courses.field.categoryHint': 'اتركه فارغاً ليتبع مجال تخصّص الخبير.',
  'adm.courses.field.isFree': 'دورة مجانية',
  'adm.courses.field.minutes': 'المدة التقديرية (بالدقائق)',
  'adm.courses.field.desc': 'وصف مختصر', 'adm.courses.field.descPh': 'لخّص محتوى الدورة وفائدتها…',
  'adm.courses.lessonModules': '{l} درساً · {m} وحدة',
  'adm.courses.manage': 'إدارة',

  // ---- portal admin: pakar ----
  'adm.instructors.sub': 'تحقّق من مؤهلات الخبراء — أهم ما يميّز المنصة.',
  'adm.instructors.add': 'إضافة خبير', 'adm.instructors.createTitle': 'إضافة خبير جديد',
  'adm.instructors.editTitle': 'تعديل الخبير',
  'adm.instructors.formSub': 'املأ ملف الخبير. المجال والجهة يحدّدان أين يظهر الخبير.',
  'adm.instructors.deleteConfirm': 'حذف الخبير "{name}"؟ تُخفى البيانات (حذف مؤقت) ويمكن استرجاعها عبر قاعدة البيانات.',
  'adm.instructors.field.avatar': 'الصورة الشخصية',
  'adm.instructors.field.name': 'الاسم الكامل', 'adm.instructors.field.namePh': 'مثال: الشيخ أحمد فوزي، ليسانس',
  'adm.instructors.field.headline': 'العنوان التعريفي', 'adm.instructors.field.headlinePh': 'خبير التجويد والقراءات السبع',
  'adm.instructors.field.category': 'مجال التخصّص',
  'adm.instructors.field.bio': 'نبذة مختصرة',
  'adm.instructors.field.bioPh': 'الخلفية العلمية، وخبرة التدريس، وطريقة عرض المادة…',
  'adm.instructors.field.verified': 'وسم «موثّق»',
  'adm.instructors.filterVerified': 'التوثيق', 'adm.instructors.unverify': 'سحب التوثيق',
  'adm.i18n.sectionTitle': 'نصوص متعددة اللغات',
  'adm.i18n.sectionHint': 'الحقول داخل هذا الإطار وحدها لها نسخة لكل لغة. الصورة والاسم والحقول أعلاه واحدة فقط.',
  'adm.i18n.sourceLang': 'لغة النص الأصلي',
  'adm.i18n.sourceHint': 'اللغة التي كتبت بها الحقول أدناه. تُبنى الترجمات على أساسها، فتأكّد من صحتها.',
  'adm.i18n.sourceBadge': '(الأصل)',
  'adm.i18n.translate': 'ترجمة بالذكاء الاصطناعي',
  'adm.i18n.saveFirst': 'احفظ أولًا، ثم ترجم.',
  'adm.i18n.translateTo': 'ترجمة إلى {lang} بالذكاء الاصطناعي',
  'adm.i18n.pickTab': 'اختر تبويب اللغة الهدف أولًا.',
  'adm.i18n.done': 'تمت الترجمة.',
  'adm.i18n.failed': 'تعذّرت الترجمة. حاول مرة أخرى بعد قليل.',
  'adm.i18n.partial': 'تعذّرت ترجمة بعض اللغات. أعد المحاولة لما زال فارغًا.',
  'adm.i18n.nothing': 'لا شيء للترجمة — كل شيء مملوء بالفعل.',
  'adm.i18n.fromAI': 'ترجمة آلية — يُرجى المراجعة والتصحيح عند الحاجة.',
  'adm.i18n.edited': 'حُرّرت يدويًا. لن تُستبدل عند إعادة الترجمة.',
  'adm.i18n.empty': 'لم تُترجم بعد. الفراغ يعني عرض النص الأصلي.',
  'adm.instructors.field.accountEmail': 'حساب الدخول (البريد الإلكتروني)',
  'adm.instructors.field.accountEmailPh': 'address@campus.edu.my',
  'adm.instructors.account.hintNew': 'املأ هذا الحقل لإنشاء حساب. ثم يسجّل الخبير في «ذا مسلم» بالعنوان نفسه.',
  'adm.instructors.account.hintNone': 'لا يوجد حساب بعد — لا يستطيع هذا الخبير تسجيل الدخول. أدخل بريدًا إلكترونيًا لإنشاء حساب.',
  'adm.instructors.account.hintWaiting': 'تم إنشاء الحساب. على الخبير الآن التسجيل في «ذا مسلم» بهذا العنوان وتأكيد بريده.',
  'adm.instructors.account.hintLinked': 'سبق أن سجّل الدخول. إفراغ هذا الحقل لا يفصل أي ارتباط.',
  'adm.instructors.account.hintMissing': 'ارتباط معلّق: الحساب لم يعد موجودًا. أدخل بريدًا جديدًا لإعادة الربط.',
  'adm.instructors.col.account': 'الحساب',
  'adm.instructors.account.none': 'لا يوجد حساب',
  'adm.instructors.account.waiting': 'بانتظار التسجيل',
  'adm.instructors.account.linked': 'نشط',
  'adm.instructors.account.missing': 'ارتباط معطوب',
  'adm.instructors.col.credentials': 'المؤهلات',

  // ---- portal admin: kelas langsung ----
  'adm.live.sub': 'جدولة حصص LiveKit ومتابعة المشاهدين.',
  'adm.live.col.session': 'الحصة', 'adm.live.col.viewers': 'المشاهدون',
  'adm.live.col.ticket': 'التذكرة', 'adm.live.col.room': 'الغرفة',

  // ---- portal admin: tanya pakar ----
  'adm.qa.sub': 'قائمة الأسئلة التي تنتظر إجابة الخبراء.',
  'adm.qa.col.question': 'السؤال', 'adm.qa.col.addressed': 'موجّه إلى',
  'adm.qa.col.received': 'تاريخ الوصول', 'adm.qa.col.answers': 'الإجابات',
  'adm.qa.answerTitle': 'إجابة السؤال', 'adm.qa.answerSend': 'إرسال الإجابة',
  'adm.qa.answerSent': 'أُرسلت الإجابة', 'adm.qa.answerLabel': 'إجابة الخبير',
  'adm.qa.answerPh': 'اكتب الإجابة مع مراجع يمكن التحقق منها…',
  'adm.qa.answerNote': 'تظهر الإجابة للعامة فوراً وتُرسل إشعاراً إلى السائل.',

  // ---- portal admin: konsultasi & pendaftaran ----
  'adm.consult.sub': 'حجوزات الجلسات الفردية وحالاتها.',
  'adm.consult.confirm': 'تأكيد', 'adm.consult.cancel': 'إلغاء',
  'adm.enroll.sub': 'من يتعلّم ماذا، وإلى أي مدى.',
  'adm.enroll.reactivate': 'إعادة التفعيل', 'adm.enroll.revoke': 'سحب الوصول',
  'adm.enroll.col.source': 'المصدر', 'adm.enroll.col.progress': 'التقدّم',
  'adm.enroll.col.enrolledAt': 'تاريخ التسجيل',

  // ---- portal admin: ulasan ----
  'adm.reviews.sub': 'مراجعة التقييمات وإخفاء المخالف منها.',
  'adm.reviews.filterStars': 'النجوم', 'adm.reviews.hide': 'إخفاء', 'adm.reviews.show': 'إظهار',
  'adm.reviews.col.author': 'الكاتب', 'adm.reviews.col.text': 'التقييم',

  // ---- portal admin: provider ----
  'adm.providers.sub': 'الجهات التي تبيع الدورات. خاص بالمنصة.',
  'adm.providers.add': 'إضافة جهة', 'adm.providers.createTitle': 'إضافة جهة جديدة',
  'adm.providers.editTitle': 'تعديل الجهة',
  'adm.providers.formSub': 'ضمّ مؤسسة أو شركة جديدة كبائع للدورات. يُنشأ المعرّف تلقائياً من الاسم.',
  'adm.providers.field.cover': 'صورة الغلاف',
  'adm.providers.field.name': 'اسم الجهة', 'adm.providers.field.namePh': 'مثال: دار تحفيظ نوسانتارا',
  'adm.providers.field.desc': 'الوصف', 'adm.providers.field.descPh': 'نبذة مختصرة عن الجهة…',
  'adm.providers.field.website': 'الموقع الإلكتروني', 'adm.providers.field.email': 'بريد التواصل',
  'adm.providers.field.emailPh': 'admin@lembaga.id',
  'adm.providers.field.share': 'حصة الجهة (%)',
  'adm.providers.field.shareHint': 'نصيب الجهة من السعر؛ والباقي للمنصة.',
  'adm.providers.field.locale': 'اللغة الافتراضية',
  'adm.providers.verify': 'توثيق',
  'adm.providers.col.share': 'الحصة', 'adm.providers.col.locale': 'اللغة',

  // ---- portal admin: kategori ----
  'adm.categories.sub': 'تصنيفات على مستوى المنصة (15 مجالاً).',
  'adm.categories.add': 'إضافة تصنيف', 'adm.categories.editTitle': 'تعديل التصنيف',
  'adm.categories.formSub': 'مجالات التخصّص في المنصة. يُستعمل المعرّف في الروابط والتصفية — اتركه فارغاً ليُنشأ تلقائياً من الاسم.',
  'adm.categories.deleteConfirm': 'حذف التصنيف "{name}"؟ سيُخفى (حذف مؤقت).',
  'adm.categories.field.nameId': 'الاسم (الإندونيسية)', 'adm.categories.field.nameIdPh': 'مثال: التحسين والتجويد',
  'adm.categories.field.nameEn': 'الاسم (الإنجليزية)', 'adm.categories.field.nameMs': 'الاسم (الملايوية)',
  'adm.categories.field.nameAr': 'الاسم (العربية)',
  'adm.categories.field.keyPh': 'tahsin-tajwid (اختياري)',
  'adm.categories.field.keyHint': 'معرّف فريد؛ يُنشأ تلقائياً من الاسم إن تُرك فارغاً.',
  'adm.categories.field.icon': 'الأيقونة (Material Symbols)',
  'adm.categories.col.accent': 'لون التمييز',
  // ---- portal admin: payout ----
  'adm.payouts.sub': 'تحويل حصص الجهات عن كل فترة.',
  'adm.payouts.markPaid': 'تعليم كمدفوع',
  'adm.payouts.col.period': 'الفترة', 'adm.payouts.col.amount': 'المبلغ', 'adm.payouts.col.method': 'الطريقة',

  // ---- portal admin: kupon ----
  'adm.coupons.sub': 'رموز الخصم: نسبة مئوية أو خصم ثابت، مع حدّ للاستخدام ومدة صلاحية.',
  'adm.coupons.add': 'إضافة كوبون', 'adm.coupons.editTitle': 'تعديل الكوبون',
  'adm.coupons.formSub': 'يُحوَّل الرمز إلى أحرف كبيرة تلقائياً. القيمة = نسبة (0–100) لنوع النسبة، أو مبلغ بالروبية للخصم الثابت.',
  'adm.coupons.deleteConfirm': 'حذف الكوبون "{code}"؟ سيُخفى (حذف مؤقت).',
  'adm.coupons.field.code': 'رمز الكوبون', 'adm.coupons.field.type': 'النوع',
  'adm.coupons.type.percent': 'نسبة مئوية (%)', 'adm.coupons.type.fixed': 'خصم ثابت (Rp)',
  'adm.coupons.field.value': 'القيمة',
  'adm.coupons.scope.all': 'كل الدورات', 'adm.coupons.scope.course': 'دورة محدّدة',
  'adm.coupons.scope.category': 'تصنيف محدّد',
  'adm.coupons.field.maxUses': 'الحد الأقصى للاستخدام', 'adm.coupons.field.maxUsesHint': '0 = بلا حد.',
  'adm.coupons.field.perUser': 'الحد الأقصى لكل مستخدم',
  'adm.coupons.field.startsAt': 'بداية الصلاحية', 'adm.coupons.field.endsAt': 'نهاية الصلاحية',
  'adm.coupons.field.providerHint': 'اتركه فارغاً لكوبون على مستوى المنصة كلها.',
  'adm.coupons.col.code': 'الرمز', 'adm.coupons.col.discount': 'الخصم',
  'adm.coupons.col.used': 'المستخدَم', 'adm.coupons.col.valid': 'الصلاحية',

  // ---- portal admin: slot konsultasi ----
  'adm.slots.sub': 'مواعيد الاستشارة الفردية التي يفتحها الخبراء للحجز.',
  'adm.slots.add': 'إضافة موعد', 'adm.slots.createTitle': 'فتح موعد استشارة',
  'adm.slots.editTitle': 'تعديل الموعد',
  'adm.slots.formSub': 'تتبع جهة الموعد جهة الخبير تلقائياً. والمواعيد المحجوزة لا يمكن إعادة فتحها من هنا.',
  'adm.slots.deleteConfirm': 'حذف هذا الموعد؟ سيُخفى (حذف مؤقت).',
  'adm.slots.field.start': 'وقت البدء', 'adm.slots.field.duration': 'المدة (بالدقائق)',
  'adm.slots.field.priceHint': '0 = مجاني.',
  'adm.slots.open': 'فتح', 'adm.slots.col.booked': 'الحجز',
  'adm.slots.booked': 'محجوز', 'adm.slots.free': 'متاح',

  // ---- portal admin: sertifikat ----
  'adm.certs.sub': 'الشهادات الصادرة؛ يمكن سحبها أو إعادة إصدارها عند الحاجة.',
  'adm.certs.reissue': 'إعادة الإصدار', 'adm.certs.revoke': 'سحب',
  'adm.certs.col.issued': 'تاريخ الإصدار', 'adm.certs.col.code': 'رمز التحقق',
  'adm.certTpl.sub': 'تصميم الشهادة: الشعار والألوان والتوقيع ونص المتن.',
  'adm.certTpl.add': 'إضافة قالب', 'adm.certTpl.createTitle': 'إضافة قالب شهادة',
  'adm.certTpl.editTitle': 'تعديل القالب',
  'adm.certTpl.formSub': 'استخدم {student} و{course} و{date} في نص المتن كعناصر نائبة تُستبدل عند الإصدار.',
  'adm.certTpl.deleteConfirm': 'حذف القالب "{name}"؟ سيُخفى (حذف مؤقت).',
  'adm.certTpl.field.name': 'اسم القالب', 'adm.certTpl.field.namePh': 'مثال: شهادة التحسين 2026',
  'adm.certTpl.field.providerHint': 'اتركه فارغاً لقالب على مستوى المنصة.',
  'adm.certTpl.field.orientation': 'الاتجاه',
  'adm.certTpl.orientation.landscape': 'أفقي', 'adm.certTpl.orientation.portrait': 'عمودي',
  'adm.certTpl.field.signature': 'التوقيع',
  'adm.certTpl.field.signName': 'اسم الموقّع', 'adm.certTpl.field.signTitle': 'صفة الموقّع',
  'adm.certTpl.field.signNamePh': 'الشيخ أحمد فوزي، ليسانس',
  'adm.certTpl.field.signTitlePh': 'المدير الأكاديمي',
  'adm.certTpl.field.body': 'نص المتن',
  'adm.certTpl.field.bodyPh': 'مُنحت إلى {student} لإتمامه {course}…',
  'adm.certTpl.field.isDefault': 'اجعله الافتراضي',
  'adm.certTpl.col.template': 'القالب', 'adm.certTpl.col.signer': 'الموقّع',

  // ---- portal admin: audit log ----
  'adm.audit.sub': 'سجل إجراءات المديرين (إنشاء/تعديل/حذف/بث). المصدر: سجل النشاط.',
  'adm.audit.col.action': 'الإجراء', 'adm.audit.col.actor': 'بواسطة', 'adm.audit.col.detail': 'التفاصيل',

  // ---- editor kelas ----
  'adm.course.tabDetail': 'التفاصيل', 'adm.course.tabPricing': 'السعر والوصول',
  'adm.course.tabSettings': 'الشهادة',
  'adm.course.viewPublic': 'عرض عام', 'adm.course.preview': 'معاينة المحتوى', 'adm.course.previewEmpty': 'لا يوجد درس للمعاينة بعد', 'adm.course.submitReview': 'إرسال للمراجعة',
  'adm.course.published': 'نُشرت الدورة', 'adm.course.rejected': 'رُفضت الدورة',
  'adm.course.rejectedBy': 'رفضها المراجع', 'adm.course.rejectBtn': 'رفض الدورة',
  'adm.course.rejectPh': 'وضّح ما يجب على الجهة تصحيحه…',
  'adm.course.title': 'العنوان', 'adm.course.estMinutes': 'المدة التقديرية بالدقائق',
  'adm.course.spokenLang': 'لغة الشرح',
  'adm.course.spokenLangHint': 'اللغة التي يتحدث بها المدرّس في الفيديو. لا تُترجَم.',
  'adm.course.descHtml': 'الوصف (HTML)', 'adm.course.objectives': 'الأهداف',
  'adm.course.addObjective': 'إضافة بند',
  'adm.course.objectivesHint': 'ما الذي سيتمكّن الطالب من فعله بعد إتمام الدورة.',
  'adm.course.objectivesPh': 'مثال: إعداد خطة جلسة إرشادية لعميل مراهق',
  'adm.course.addRequirement': 'إضافة عنصر',
  'adm.course.requirementsHint': 'ما ينبغي للطالب تجهيزه. هذا لا يقفل الدورة — القفل هو حقل المتطلّب السابق أدناه.',
  'adm.course.requirementsPh': 'مثال: أن يكون قد أنهى دورة الإرشاد الأساسية',
  'adm.course.addAudience': 'إضافة فئة مستهدفة',
  'adm.course.audienceHint': 'من هم الأنسب لحضور هذه الدورة.',
  'adm.course.audiencePh': 'مثال: المرشدون الطلابيون في المدارس الثانوية',
  'adm.course.thumbnail': 'الصورة المصغّرة', 'adm.course.thumbHint': 'نسبة 16:9، بحدّ أدنى 1280×720، وبحدّ أقصى 8 MB.',
  'adm.course.slug': 'المعرّف في الرابط', 'adm.course.comparePrice': 'السعر المرجعي',
  'adm.course.accessType': 'نوع الوصول', 'adm.course.access.lifetime': 'دائم',
  'adm.course.access.expiry': 'ينتهي بعد N يوماً', 'adm.course.access.subscription': 'اشتراك',
  'adm.course.accessDays': 'مدة الوصول (بالأيام)',
  'adm.course.certOnComplete': 'إصدار الشهادة عند الإتمام',
  'adm.course.completionRule': 'شرط الإتمام',
  'adm.course.completionRule1': 'إكمال 100% من الدروس · النجاح في الاختبار النهائي (الدرجة ≥ 70)',
  'adm.course.completionRule2': 'يُحتسب الفيديو مكتملاً عند 90% من مدته (SCORM/cmi5: الإتمام ≠ النجاح).',

  // ---- editor kelas: kesiapan ----
  'adm.ready.title': 'جاهزية الدورة', 'adm.ready.count': '{n}/{total} جاهز',
  'adm.ready.live': 'هذه الدورة تظهر في المتجر.',
  'adm.ready.waiting': 'بانتظار مراجعة مدير المنصة',
  'adm.ready.remaining': 'بقيت {n} خطوة',
  'adm.ready.detail': 'تفاصيل الدورة', 'adm.ready.detailDone': 'الوصف والأهداف مكتملة',
  'adm.ready.detailTodo': 'املأ الوصف وهدفاً واحداً على الأقل',
  'adm.ready.curriculum': 'المنهج الدراسي',
  'adm.ready.curriculumTodo': 'أضف وحدة واحدة ودرساً واحداً على الأقل',
  'adm.ready.quiz': 'أسئلة الاختبار', 'adm.ready.quizDone': 'كل الاختبارات فيها أسئلة',
  'adm.ready.quizTodo': '{n} اختبار بلا أسئلة',
  'adm.ready.priceTodo': 'حدّد السعر أو علّم الدورة كمجانية',

  // ---- editor kurikulum ----
  'adm.cur.loading': 'جارٍ تحميل المنهج…', 'adm.cur.saved': 'تم حفظ المنهج',
  'adm.cur.addModule': 'إضافة وحدة', 'adm.cur.addLesson': 'إضافة درس',
  'adm.cur.moduleN': 'الوحدة {n}', 'adm.cur.newLesson': 'درس جديد',
  'adm.cur.count': '{m} وحدة · {l} درساً',
  'adm.cur.unsaved': 'لم يُحفَظ', 'adm.cur.save': 'حفظ المنهج',
  'adm.cur.drip.none': 'الإتاحة: فوراً', 'adm.cur.drip.days': 'الإتاحة: بعد N يوماً', 'adm.cur.drip.date': 'الإتاحة: تاريخ محدّد',
  'adm.cur.seconds': 'ثانية', 'adm.cur.preview': 'معاينة',
  'adm.cur.saveFirst': 'احفظ أولاً',
  'adm.cur.saveFirstHint': 'احفظ المنهج أولاً ليحصل الدرس على رقم معرّف',
  'adm.a11y.moveUp': 'رفع', 'adm.a11y.moveDown': 'خفض', 'adm.a11y.delete': 'حذف',

  // ---- editor kuis ----
  'adm.quiz.title': 'إدارة الأسئلة · {lesson}', 'adm.quiz.save': 'حفظ الاختبار', 'adm.quiz.saved': 'تم حفظ الاختبار',
  'adm.quiz.passing': 'درجة النجاح (%)', 'adm.quiz.timeLimit': 'المهلة الزمنية (بالدقائق)',
  'adm.quiz.maxAttempts': 'الحد الأقصى للمحاولات',
  'adm.quiz.question': 'الأسئلة', 'adm.quiz.questionPh': 'اكتب السؤال…',
  'adm.quiz.deleteQuestion': 'حذف السؤال', 'adm.quiz.deleteOption': 'حذف الخيار',
  'adm.quiz.type': 'النوع', 'adm.quiz.points': 'النقاط',
  'adm.quiz.qtype.single': 'اختيار واحد', 'adm.quiz.qtype.multi': 'اختيار متعدّد (يجوز أكثر من إجابة صحيحة)',
  'adm.quiz.qtype.tf': 'صح / خطأ',
  'adm.quiz.options': 'خيارات الإجابة', 'adm.quiz.optionsHint': '(علّم الصحيح منها)',
  'adm.quiz.markCorrect': 'تعليم كإجابة صحيحة', 'adm.quiz.optionN': 'الخيار {n}', 'adm.quiz.addOption': 'إضافة خيار',
  'adm.quiz.explanation': 'الشرح (اختياري)', 'adm.quiz.explanationPh': 'يظهر بعد الإجابة',
  'adm.quiz.addQuestion': 'إضافة سؤال', 'adm.quiz.empty': 'لا توجد أسئلة بعد. اضغط «إضافة سؤال».',
  'adm.quiz.err.noText': 'يوجد سؤال بلا نص',
  'adm.quiz.err.minOptions': 'كل سؤال يحتاج خيارين على الأقل',
  'adm.quiz.err.emptyOption': 'يوجد خيار إجابة فارغ',
  'adm.quiz.err.noCorrect': 'كل سؤال يحتاج إجابة صحيحة واحدة على الأقل',

  // ---- dasbor admin ----
  'adm.dash.period': 'الفترة: {label}.', 'adm.dash.loading': 'جارٍ تحميل الملخّص…', 'adm.dash.export': 'تصدير',
  'adm.dash.guideTitle': 'جديد هنا؟ ابدأ من الدليل.',
  'adm.dash.guideSub': 'ترتيب إدخال المحتوى، والحقول الإلزامية، والمزالق التي كثيراً ما تُفشل إرسال الدورة.',
  'adm.dash.guideCta': 'فتح الدليل',
  'adm.dash.enrollments': 'التسجيلات',
  'adm.dash.lessonsDone': 'الدروس المكتملة (North Star)', 'adm.dash.lessonsHint': 'مؤشر القيمة التعليمية الحقيقية',
  'adm.dash.certsIssued': 'الشهادات الصادرة',
  'adm.dash.funnelTitle': 'قمع الشراء', 'adm.dash.funnelRange': '{first} → الدفع',
  'adm.dash.funnelConversion': 'التحويل النهائي',
  'adm.dash.funnelNoVisits': 'لم تُسجَّل أي زيارة هذا الشهر، لذا لا يمكن حساب نسبة التحويل. ويبدأ التسجيل تلقائياً بمجرد أن يفتح زائر الكتالوج.',
  'adm.dash.funnelEmpty': 'لا توجد زيارات للكتالوج هذا الشهر. تبدأ الزيارات بالتسجيل بمجرد أن يفتح أحد صفحة الدورات — أما زيارات المديرين أنفسهم فلا تُحتسب عمداً.',
  'adm.dash.queueAll': 'كل قائمة الانتظار', 'adm.dash.queueClean': 'لا شيء في الانتظار 🎉',
  'adm.dash.submitted': 'أُرسلت {ago}', 'adm.dash.lessonCount': '{n} درساً', 'adm.dash.reviewCta': 'مراجعة',
  'adm.dash.topCourses': 'الدورات الأكثر مبيعاً', 'adm.dash.enrollCount': '{n} تسجيلاً',
  'adm.dash.topCoursesEmpty': 'لا توجد دورة لها مسجّلون بعد. تمتلئ هذه القائمة تلقائياً بمجرد أن يلتحق أحد بأول دورة.',
  'adm.dash.health': 'صحة المنصة', 'adm.dash.payoutsWaiting': 'تحويلات منتظرة',
  'adm.dash.reviewsToCheck': 'تقييمات تحتاج مراجعة',
  'adm.dash.recentOrders': 'أحدث الطلبات', 'adm.dash.orderNoItems': '(بلا تفاصيل بنود)',
  'adm.dash.ordersEmpty': 'لا توجد طلبات بعد.',
  'adm.dash.csv.metric': 'المؤشر', 'adm.dash.csv.value': 'القيمة', 'adm.dash.csv.period': 'الفترة',
  'adm.dash.csv.gmv': 'GMV', 'adm.dash.csv.lessonsDone': 'الدروس المكتملة',
  'adm.dash.csv.month': 'الشهر', 'adm.dash.csv.funnelStage': 'مرحلة القمع',
  'adm.dash.csv.count': 'العدد', 'adm.dash.csv.revenue': 'الإيرادات',

  // ---- kerangka portal admin ----
  'adm.gate.title': 'لوحة إدارة KnowledgeX',
  'adm.gate.sub': 'ادخل بحساب مدير منصة أو مدير جهة، باستخدام البريد الإلكتروني وكلمة المرور اللذين زوّدك بهما الفريق التقني.',
  'adm.gate.login': 'الدخول كمدير', 'adm.gate.storefront': 'إلى المتجر',
  'adm.role.platform': 'مدير المنصة', 'adm.role.provider': 'مدير جهة',
  'adm.scope.all': 'كل الجهات', 'adm.scope.provider': 'النطاق: {name}',
  'adm.nav.storefront': 'المتجر',

  // ---- daftar langkah onboarding ----
  'adm.onb.fabTitle': 'الخطوات الأولى للخبراء الجدد', 'adm.onb.fabLabel': 'الخطوات الأولى — بقيت {n} خطوة',
  'adm.onb.fabTip': 'الخطوات الأولى',
  'adm.onb.panelTitle': 'ابدأ من هنا', 'adm.onb.checking': 'جارٍ الفحص…',
  'adm.onb.progress': 'أُنجزت {n} من {total}',
  'adm.onb.doneTitle': 'اكتملت كل الخطوات 🎉',
  'adm.onb.donePlatform': 'صار في الكتالوج دورات ظاهرة.',
  'adm.onb.doneProvider': 'وصلت دورتك إلى مرحلة المراجعة.',
  'adm.onb.doneTail': 'يبقى الدليل الكامل متاحاً في أي وقت من القائمة',
  'adm.onb.doneClose': 'انتهيت، أغلق هذه القائمة', 'adm.onb.doneLater': 'لاحقاً',
  'adm.onb.hideForever': 'إخفاء نهائياً',
  'adm.onb.step.guide': 'اقرأ الدليل المختصر', 'adm.onb.step.guideDone': 'تم فتحه',
  'adm.onb.step.guideTodo': 'يحتوي على لقطات شاشة لكل خطوة',
  'adm.onb.step.instructor': 'أضف خبيراً مدرّباً',
  'adm.onb.step.instructorDone': '{n} خبير مسجّل',
  'adm.onb.step.instructorTodo': 'كل دورة تحتاج خبيراً واحداً',
  'adm.onb.step.course': 'أنشئ أول دورة', 'adm.onb.step.courseDone': 'أُنشئت {n} دورة',
  'adm.onb.step.courseTodo': 'ابدأ بالعنوان والخبير المدرّب',
  'adm.onb.step.detail': 'املأ التفاصيل والأهداف', 'adm.onb.step.detailDone': 'الوصف و{n} هدف مكتملة',
  'adm.onb.step.syllabus': 'رتّب المنهج', 'adm.onb.step.price': 'حدّد السعر أو اجعلها مجانية',
  'adm.onb.step.priceTodo': 'حدّد السعر، أو علّمها كمجانية',
  'adm.onb.needCourse': 'تحتاج دورة واحدة أولاً',
  'adm.onb.step.curatePlatform': 'راجع الدورة وانشرها',
  'adm.onb.curate.published': '{n} دورة ظاهرة في الكتالوج',
  'adm.onb.curate.waiting': '{n} دورة تنتظر المراجعة',
  'adm.onb.curate.none': 'لا توجد دورة جاهزة للمراجعة',
  'adm.onb.submit.published': 'توجد دورة ظاهرة بالفعل',
  'adm.onb.submit.waiting': 'قيد المراجعة لدى مدير المنصة',
  'adm.onb.submit.todo': 'أرسلها إلى مدير المنصة بعد اكتمال الجاهزية 4/4',

  // ---- pendapatan ----
  'adm.earn.col.order': 'الطلب', 'adm.earn.col.share': 'الحصة',
  'adm.earn.col.availableAt': 'تاريخ الصرف',
  'adm.earn.paid': 'مدفوعة',

  // ---- broadcast notifikasi ----
  'adm.bc.sub': 'أرسل إعلاناً أو إشعاراً إلى جمهور محدّد. يظهر في جرس إشعارات المستخدم.',
  'adm.bc.audience': 'الجمهور', 'adm.bc.kind': 'النوع',
  'adm.bc.aud.students': 'كل المتعلّمين', 'adm.bc.aud.providers': 'مديرو الجهات',
  'adm.bc.aud.admins': 'مديرو المنصة', 'adm.bc.aud.all': 'كل المستخدمين',
  'adm.bc.kind.announcement': 'إعلان', 'adm.bc.kind.promo': 'عرض ترويجي', 'adm.bc.kind.system': 'النظام',
  'adm.bc.title': 'العنوان', 'adm.bc.titlePh': 'مثال: دورة جديدة: التحسين المستوى 2 متاحة الآن!',
  'adm.bc.body': 'نص الرسالة', 'adm.bc.bodyPh': 'اكتب رسالة قصيرة وواضحة…',
  'adm.bc.note': 'تُرسَل فوراً؛ ولا يمكن التراجع عنها.',
  'adm.bc.send': 'إرسال البث', 'adm.bc.sent': 'أُرسل {n} إشعاراً',
  'adm.bc.failed': 'تعذّر الإرسال',
  'adm.bc.recent': 'أحدث الإشعارات',
  'adm.bc.col.body': 'المحتوى', 'adm.bc.col.read': 'مقروء',

  /* ---- akun pakar, direktori pakar & skala kategori ---- */
  'nav.profile': 'ملف الخبير',
  'nav.account': 'حساب The Muslim', 'nav.language': 'اللغة',
  'nav.instructors': 'الخبراء',
  'acc.title': 'حسابي',
  'acc.sub': 'أدر ملفك العام وأمان حسابك.',
  'acc.tab.profile': 'ملف الخبير',
  'acc.tab.security': 'الأمان',
  'acc.save': 'حفظ الملف',
  'acc.saved': 'تم حفظ الملف',
  'acc.readonlyNote': 'يديرها المشرف. تواصل مع مشرف الجهة لتغييرها.',
  'acc.noProfile': 'لا يوجد ملف خبير مرتبط بهذا الحساب',
  'acc.noProfileHint': 'اطلب من مشرف الجهة ربط ملف بحسابك.',
  'acc.field.avatar': 'صورة الملف',
  'acc.field.headline': 'العنوان المختصر',
  'acc.field.headlineHint': 'سطر واحد عن مجال خبرتك. 160 حرفًا كحد أقصى.',
  'acc.field.bio': 'نبذة',
  'acc.field.bioHint': 'خلفيتك وأبحاثك وخبرتك. 4000 حرف كحد أقصى.',
  'acc.field.social': 'الروابط',
  'acc.field.socialHint': 'يجب أن يبدأ بـ https://',
  'acc.social.linkedin': 'لينكدإن',
  'acc.social.web': 'الموقع',
  'acc.social.scholar': 'جوجل سكولر',
  'acc.social.youtube': 'يوتيوب',
  'acc.social.instagram': 'إنستغرام',
  'acc.social.x': 'إكس',
  'acc.field.credentials': 'المؤهلات',
  'acc.cred.title': 'العنوان',
  'acc.cred.issuer': 'الجهة / التفاصيل',
  'acc.cred.year': 'السنة',
  'acc.cred.add': 'إضافة مؤهل',
  'acc.cred.remove': 'حذف',
  'acc.cred.empty': 'لا توجد مؤهلات بعد.',
  'acc.readonly.name': 'الاسم',
  'acc.readonly.category': 'المجال',
  'acc.readonly.provider': 'الجهة',
  'acc.complete.title': 'اكتمال الملف',
  'acc.complete.sub': 'أكمل جميع الأقسام ليتمكن المشرف من توثيق ملفك.',
  'acc.complete.count': '{n} من {total} مكتمل',
  'acc.pw.title': 'أمان الحساب',
  'acc.pw.sub': 'كلمة المرور والبريد والاسم تُدار في The Muslim — حساب واحد لكل الخدمات.',
  'acc.pw.manage': 'إدارة حساب The Muslim',
  'acc.pw.unavailable': 'لم يتم ضبط عنوان حساب The Muslim على هذا الخادم.',
  'adm.role.instructor': 'خبير',
  'adm.role.student': 'طالب',
  'adm.gate.instructorSub': 'حسابات الخبراء لا تصل إلى بوابة المشرف. أدر ملفك من صفحة حسابي.',
  'adm.gate.instructorCta': 'إلى ملفي',
  'ins.new': 'خبير جديد',
  'ins.stat.rating': 'التقييم',
  'ins.stat.students': 'الطلاب',
  'ins.stat.courses': 'الدورات',
  'ins.stat.answered': 'أسئلة مُجابة',
  'ins.coursesBy': 'دورات {name}',
  'ins.noCourses': 'لا توجد دورات بعد',
  'ins.noCoursesHint': 'لم ينشر هذا الخبير أي دورة بعد.',
  'ins.noSlots': 'لا توجد مواعيد استشارة بعد.',
  'ins.consultSub': 'جلسة خاصة عبر مكالمة فيديو.',
  'insList.title': 'الخبراء',
  'insList.sub': '{n} خبيرًا منتقى في مختلف المجالات.',
  'insList.search': 'ابحث بالاسم أو التخصص…',
  'insList.allCategories': 'كل المجالات',
  'insList.empty': 'لم يُعثر على خبراء',
  'insList.emptyHint': 'جرّب كلمة أخرى أو اختر مجالًا مختلفًا.',
  'home.categoriesSub': '{n} مجالًا بمعيار انتقاء واحد.',
  'cat.courseCount': '{n} دورة',
  'cat.filterSearch': 'ابحث عن مجال…',
  'cat.none': 'لم يُعثر على مجال',
  'cat.seeAllExperts': 'عرض كل الخبراء',

  // ——— kredit, bagi hasil, video pelajaran, ruang kerja pakar ———
  'vid.title': 'فيديو الدرس',
  'vid.none': 'لا يوجد فيديو بعد',
  'vid.upload': 'رفع فيديو',
  'vid.dropHint': 'اسحب ملف MP4 إلى هنا',
  'vid.choose': 'اختر ملفًا',
  'vid.replace': 'استبدال الفيديو',
  'vid.remove': 'حذف الفيديو',
  'vid.uploading': 'جارٍ الرفع… {pct}%',
  'vid.finishing': 'جارٍ الإنهاء…',
  'vid.ready': 'الفيديو جاهز',
  'vid.failed': 'فشل الرفع',
  'vid.retry': 'حاول مرة أخرى',
  'vid.cancel': 'إلغاء',
  'vid.tooLarge': 'الحد الأقصى لحجم الفيديو 2 غيغابايت.',
  'vid.wrongType': 'ملفات MP4 فقط مدعومة.',
  'vid.slowStart': 'سيبدأ هذا الفيديو ببطء. أعد تصديره بخيار "faststart" حتى لا ينتظر المشاهدون.',
  'vid.durationMin': '{n} دقيقة',
  'vid.preview': 'تشغيل المعاينة',
  'vid.keepTab': 'أبقِ هذه الصفحة مفتوحة حتى ينتهي الرفع.',
  'vid.onlyVideoLesson': 'رفع الفيديو مخصص لدروس الفيديو فقط.',
  'price.credits': 'السعر (أرصدة)',
  'price.creditsHint': 'ما يدفعه الطالب، بالأرصدة.',
  'price.compareCredits': 'السعر قبل الخصم (أرصدة)',
  'price.locked': 'السعر مقفل',
  'price.lockedHint': 'لا يمكن تغيير السعر بعد إرسال الدورة أو نشرها. تواصل مع المشرف عند الحاجة.',
  'price.creditUnit': 'رصيد',
  'cur.submit': 'إرسال للمراجعة',
  'cur.submitting': 'جارٍ الإرسال…',
  'cur.ready': 'جاهز للإرسال',
  'cur.notReady': 'غير جاهز بعد',
  'cur.problems': 'ما الذي ما زال ناقصًا',
  'cur.waiting': 'في انتظار مراجعة المشرف',
  'cur.rejectedReason': 'سبب الإرجاع',
  'cur.fixAndResubmit': 'صحّح ثم أرسل مرة أخرى.',
  'pd.title': 'مساحة عمل الخبير',
  'pd.cardCourses': 'دوراتي',
  'pd.cardStudents': 'الطلاب',
  'pd.cardCuration': 'قائمة المراجعة',
  'pd.published': '{n} منشورة',
  'pd.draftCount': '{n} مسودة',
  'pd.pendingCount': '{n} قيد الانتظار',
  'pd.rejectedCount': '{n} مُعادة',
  'pd.activeStudents': '{n} نشط',
  'pd.completedStudents': '{n} مكتمل',
  'pd.needsAttention': 'يحتاج إلى إجراء',
  'pd.allGood': 'لا شيء يحتاج إلى إصلاح.',
  'pd.recentStudents': 'أحدث الطلاب',
  'pd.noStudents': 'لا يوجد طلاب بعد.',
  'pd.privacyNote': 'ترى الأسماء والصور فقط. لا تتم مشاركة بيانات التواصل مع الطلاب.',
  'pd.myCourses': 'دوراتي',
  'pd.newCourse': 'دورة جديدة',
  'pd.reorder': 'ترتيب الدورات',
  'pd.noCourses': 'لا توجد دورات بعد',
  'pd.noCoursesHint': 'ابدأ بإنشاء دورتك الأولى.',
  'pd.videoReady': '{a}/{b} فيديو جاهز',
  'pd.reason.no_lessons': 'لا توجد دروس بعد',
  'pd.reason.missing_video': 'درس فيديو بلا فيديو',
  'pd.reason.no_price': 'لم يتم تحديد السعر',
  'pd.reason.rejected': 'أعادها المشرف',
  'pd.reason.draft_stale': 'مسودة قديمة لم تُرسل',
  'wal.title': 'محفظة الأرصدة',
  'wal.balance': 'رصيد الأرصدة',
  'wal.withdrawable': 'قابل للسحب',
  'wal.topup': 'شحن الرصيد',
  'wal.history': 'سجل الأرصدة',
  'wal.amount': 'عدد الأرصدة',
  'wal.willPay': 'ما ستدفعه',
  'wal.create': 'إنشاء فاتورة',
  'wal.manualNote': 'بعد الدفع، يؤكّد المشرف وتصل الأرصدة إلى محفظتك.',
  'wal.empty': 'لا توجد معاملات بعد.',
  'wal.topupsTitle': 'فواتير الشحن',
  'wal.capNote': 'يمكن سحب أرصدة العمولة فقط نقدًا. أرصدة الشحن مخصصة لشراء الدورات.',
  'wal.kind.topup': 'شحن',
  'wal.kind.purchase': 'شراء دورة',
  'wal.kind.commission': 'عمولة',
  'wal.kind.withdrawal': 'سحب',
  'wal.kind.adjustment': 'تسوية',
  'wal.kind.withdrawal_reversal': 'إرجاع السحب',
  'wal.status.pending': 'في انتظار الدفع',
  'wal.status.paid': 'مدفوع',
  'wal.status.failed': 'فشل',
  'wal.status.expired': 'منتهي',
  'wal.currency': 'الدفع بعملة',
  'wal.payWith': 'مزوّد الدفع',
  'wal.channel': 'ادفع بواسطة',
  'wal.suggested': 'مقترح',
  'wal.noGateway': 'لا توجد طريقة دفع مفعّلة بعد. يرجى التواصل مع الإدارة.',
  'wal.minimum': 'الحد الأدنى لهذه الطريقة:',
  'wal.continuePay': 'متابعة الدفع',
  'wal.gw.stripe': 'بطاقة ائتمان / خصم',
  'wal.gw.doku': 'QRIS وتحويل ومحفظة إلكترونية',
  'wal.gw.manual': 'تحويل يدوي',
  'wal.gwHint.stripe': 'فيزا، ماستركارد. يُحتسب بالرينغيت (MYR).',
  'wal.gwHint.doku': 'QRIS، حساب افتراضي، OVO، DANA. يُحتسب بالروبية (IDR).',
  'wal.gwHint.manual': 'تحويل مباشر، تؤكده الإدارة.',
  'wal.ret.checking': 'جارٍ التحقق من دفعتك. تُضاف الأرصدة تلقائياً بعد تأكيد مزوّد الدفع — عادةً في أقل من دقيقة.',
  'wal.ret.paid': 'تم استلام الدفعة. الأرصدة موجودة الآن في محفظتك.',
  'wal.ret.cancelled': 'أُلغيت عملية الدفع. الفاتورة محفوظة ويمكن متابعتها من القائمة أدناه.',
  'wal.ret.failed': 'لم تتم عملية الدفع. لم يُخصم أي مبلغ؛ يرجى المحاولة مرة أخرى.',
  'aff.title': 'التسويق بالعمولة',
  'aff.code': 'رمزك',
  'aff.link': 'رابطك',
  'aff.copy': 'نسخ',
  'aff.copied': 'تم النسخ',
  'aff.referred': 'الأشخاص المُحالون',
  'aff.earned': 'العمولة المكتسبة',
  'aff.pendingCredits': 'في انتظار الصرف',
  'aff.sales': 'المبيعات',
  'aff.recent': 'أحدث العمولات',
  'aff.empty': 'لا توجد عمولة بعد.',
  'aff.hint': 'شارك هذا الرابط. من يسجّل عبره يرتبط بحسابك بشكل دائم.',
  'aff.permanentNote': 'يُحدَّد هذا الارتباط مرة واحدة ولا يتغيّر.',
  'wd.title': 'الصرف',
  'wd.available': 'متاح الآن',
  'wd.held': 'ضمن فترة الحجز',
  'wd.feePct': 'رسوم {pct}%',
  'wd.net': 'ما ستستلمه',
  'wd.request': 'طلب الصرف',
  'wd.min': 'الحد الأدنى {n} رصيد',
  'wd.method': 'طريقة الاستلام',
  'wd.methodPh': 'مثال: تحويل بنكي إلى …',
  'wd.history': 'سجل الصرف',
  'wd.empty': 'لا توجد عمليات صرف بعد.',
  'wd.sent': 'تم إرسال طلب الصرف',
  'wd.holdNote': 'تصبح العمولة قابلة للصرف بعد فترة الحجز. هذا يحمي من عكس المدفوعات.',
  'wd.status.requested': 'مطلوب',
  'wd.status.approved': 'موافق عليه',
  'wd.status.paid': 'تم الدفع',
  'wd.status.rejected': 'مرفوض',
  'wd.source.instructor': 'عمولة التدريس',
  'wd.source.affiliate': 'عمولة الإحالة',
  'wd.source.provider': 'عمولة المؤسسة',
  'co.payWithCredits': 'ادفع بالأرصدة',
  'co.yourBalance': 'رصيدك',
  'co.creditWallet': 'محفظة الأرصدة',
  'co.creditWalletNote': 'رصيدك وعمليات الشحن تُدار في حساب The Muslim الخاص بك.',
  'co.short': 'ينقصك {n} رصيد',
  'co.topupFirst': 'اشحن الرصيد أولًا',
  'co.paying': 'جارٍ المعالجة…',
  'ams.title': 'إعدادات المال',
  'ams.rate': 'سعر رصيد واحد',
  'ams.currency': 'العملة',
  'ams.split': 'تقسيم الإيرادات',
  'ams.platform': 'ذا مسلم',
  'ams.provider': 'المزوّد',
  'ams.instructor': 'الخبير',
  'ams.affiliate': 'المُحيل',
  'ams.mustBe100': 'يجب أن يكون المجموع 100% بالضبط.',
  'ams.total': 'المجموع {n}%',
  'ams.withdrawFee': 'رسوم الصرف (%)',
  'ams.withdrawMin': 'الحد الأدنى للصرف (أرصدة)',
  'ams.hold': 'فترة الحجز (أيام)',
  'ams.vat': 'ضريبة القيمة المضافة',
  'ams.vatOn': 'تفعيل الضريبة',
  'ams.vatPct': 'نسبة الضريبة (%)',
  'ams.vatPoint': 'نقطة التحصيل',
  'ams.vatPoint.topup': 'عند الشحن',
  'ams.vatPoint.purchase': 'عند شراء الدورة',
  'ams.vatWarn': 'الضريبة معطّلة. فعّلها فقط بعد تأكيد النسبة ونقطة التحصيل.',
  'ams.topupFee': 'رسوم الشحن (%)',
  'ams.topupFeeFlat': 'رسوم ثابتة للشحن',
  'ams.example': 'مثال: عملية شراء بـ10 أرصدة',
  'ams.saved': 'تم حفظ إعدادات المال',
  'ams.ch.tab': 'طرق الدفع',
  'ams.ch.name': 'طريقة الدفع',
  'ams.ch.gateway': 'المزوّد',
  'ams.ch.feeBps': 'النسبة (نقطة أساس)',
  'ams.ch.feeFlat': 'رسوم ثابتة',
  'ams.ch.vat': 'الضريبة (نقطة أساس)',
  'ams.ch.effective': 'الفعلي',
  'ams.ch.on': 'مفعّل',
  'ams.ch.off': 'معطّل',
  'ams.ch.noCode': 'لا يوجد رمز مزوّد',
  'ams.ch.empty': 'لا توجد طرق دفع بعد.',
  'ams.gross': 'الإجمالي',
  'ams.fee': 'رسوم المزوّد',
  'ams.net': 'الصافي المستلم',
  'ams.markPaid': 'وضع علامة مدفوع',
  'ams.payNow': 'صرف',
  'ams.rejectWd': 'رفض',
  'nav.wallet': 'المحفظة',
  'nav.affiliate': 'الإحالة',
  'admin.myCourses': 'دوراتي',
  'admin.money': 'إعدادات المال',
  'admin.topups': 'عمليات الشحن',
  'admin.withdrawals': 'الصرف',
  'admin.workspaceOnly': 'مساحة عمل الخبير',
  'adm.gate.instructorCta': 'إلى مساحة عملي',
  'aff.haveCode': 'هل لديك رمز إحالة؟',
  'aff.enterCode': 'أدخل الرمز',
  'aff.apply': 'تطبيق',
  'aff.applied': 'تم تعيين المُحيل',
  'aff.onlyBefore': 'يمكن تعيين الرمز قبل أول عملية شراء فقط.',
  'aff.myReferrer': 'تم تعيين المُحيل الخاص بك بالفعل.',

  // ---- kredit: dasbor + buku besar bagi hasil ----
  'adm.dash.creditsMonth': 'الأرصدة هذا الشهر',
  'adm.dash.credits12': 'الأرصدة خلال 12 شهراً',
  'adm.dash.credits12sub': 'الطلبات المدفوعة، شهرياً',
  'adm.earn.sub': 'سجل تقاسم الإيرادات، صف لكل مستفيد. جميع القيم بالأرصدة.',
  'adm.earn.total': 'إجمالي الأرصدة',
  'adm.earn.col.payee': 'المستفيد',
  'adm.earn.col.credits': 'الأرصدة',
  'adm.earn.col.payeeType': 'الدور',
  'adm.earn.payee.platform': 'المنصة',
  'adm.earn.payee.provider': 'الجهة',
  'adm.earn.payee.instructor': 'الخبير',
  'adm.earn.payee.affiliate': 'المُحيل',
  'adm.earn.legacy': '{n} صفوف روبية قديمة غير مشمولة في المجموع.',
  'adm.earn.unclaimed': 'بلا مالك',
  // المتطلب السابق ومسار التعلم (§21).
  'course.prereqLocked': 'أكمل هذه الدورة أولاً:',
  'course.prereqAdvised': 'يُنصح بإكمالها أولاً:',
  'course.prereqGo': 'افتح الدورة المطلوبة',
  'course.path': 'مسار التعلم',
  'course.pathHint': 'الترتيب الذي يقترحه المدرّب.',
  'course.pathBefore': 'قبل هذه',
  'course.pathNow': 'هذه الدورة',
  'course.pathNext': 'التالية',
  'adm.course.prereq': 'الدورة المطلوبة مسبقاً',
  'adm.course.prereqNone': 'بدون متطلب سابق',
  'adm.course.prereqHint': 'الدورة التي يُفترض إكمالها أولاً. دوراتك أنت فقط.',
  'adm.course.prereqRequired': 'يجب إكمالها أولاً',
  'adm.course.prereqLocked': 'لا يمكن للطلاب شراء هذه الدورة قبل اجتياز المتطلب السابق.',
  'adm.course.prereqAdvised': 'تُعرض كنصيحة فقط. تبقى الدورة قابلة للشراء.',
  'course.payNote': 'الدفع بالأرصدة · يُفتح الوصول فوراً',
  'adm.coupons.field.valueCredits': 'خصم ثابت (أرصدة)',
  'adm.coupons.field.valueCreditsHint': "يُستخدم فقط عندما يكون نوع الكوبون 'fixed'. أما 'percent' فاملأ حقل القيمة.",

  // --- إشعارات البريد للمراجعة ---
  'adm.bc.tab.send': 'إرسال إعلان',
  'adm.bc.tab.email': 'بريد تلقائي',
  'adm.notif.smtp': 'إرسال البريد',
  'adm.notif.smtpOn': 'جاهز',
  'adm.notif.smtpOff': 'غير مُعدّ',
  'adm.notif.smtpFrom': 'يُرسل من {from}',
  'adm.notif.smtpHint': 'بيانات SMTP غير مُعبّأة على الخادم، لذا لن يصل أي بريد حتى لو امتلأت القائمة أدناه. عبّئ SMTP_HOST و SMTP_FROM في ملف ‎.env‎ الخاص بالخادم.',
  'adm.notif.curation': 'أرسل بريدًا عند تقديم دورة للمراجعة',
  'adm.notif.curationHint': 'تُنشأ الإشعارات داخل اللوحة حتى لو كان هذا مُعطَّلًا. هذا يضيف البريد، حتى لا تتراكم قائمة المراجعة لمجرد أن أحدًا لم يفتح اللوحة.',
  'adm.notif.recipients': 'عناوين المستلمين',
  'adm.notif.addEmail': 'إضافة عنوان',
  'adm.notif.removeEmail': 'حذف العنوان',
  'adm.notif.noRecipients': 'لا توجد عناوين بعد. بدون مستلم واحد، لا يمكن إرسال أي بريد.',
  'adm.notif.decision': 'أبلغ الخبير عند قبول دورته أو رفضها',
  'adm.notif.decisionHint': 'يُرسل إلى بريد حساب صاحب الدورة. وفي حالة الرفض يُرفق السبب.',
  'adm.notif.save': 'حفظ الإعدادات',
  'adm.notif.test': 'إرسال بريد تجريبي',
  'adm.notif.testSent': 'أُرسل البريد التجريبي إلى {n} عنوانًا.',
  'adm.notif.testFailed': 'فشل إرسال البريد التجريبي.',
}
